module.exports = __webpack_public_path__ + "static/img/drew-tape.f0a8f20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/drew-tape.png
// module id = nMs/
// module chunks = 0